module.exports = __webpack_public_path__ + "static/media/icon-remarketing-deselecionado.d2a35368.svg";